import * as signalR from '@microsoft/signalr';
import { useEffect, useState } from 'react';
import apiClient from '../utils/apiClient';
import { API_SERVER } from '../utils/constants';

export const useSignalR = flowId => {
  const [receivedData, setReceivedData] = useState(null);
  const [connection, setConnection] = useState(null);

  useEffect(() => {
    if (!flowId) return;

    let token = localStorage.getItem('accessToken');

    if (!token && apiClient.defaults.headers.common['Authorization']) {
      token = apiClient.defaults.headers.common['Authorization'].replace(
        'Bearer ',
        ''
      );
    }

    if (!token) {
      console.error('❌ Hata: JWT token bulunamadı.');
      return;
    }

    if (connection) {
      console.warn('⚠️ Mevcut SignalR bağlantısı kapatılıyor...');
      connection.stop();
    }

    const newConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_SERVER}/hub/flow?flowId=${flowId}`, {
        accessTokenFactory: () => token,
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
        withCredentials: true,
      })
      .withHubProtocol(new signalR.JsonHubProtocol()) // 📌 JSON formatı kullan
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    setConnection(newConnection);

    return () => {
      newConnection.stop();
    };
  }, [flowId]);

  useEffect(() => {
    if (!connection) return;

    connection
      .start()
      .catch(err => console.error('❌ SignalR bağlantı hatası:', err));

    connection.on('receiveflowvalue', data => {
      try {
        let parsedData = data;

        if (typeof data === 'string') {
          parsedData = JSON.parse(data);
        }

        if (
          parsedData.arguments &&
          typeof parsedData.arguments[0] === 'string'
        ) {
          parsedData.arguments[0] = JSON.parse(parsedData.arguments[0]);
        }

        setReceivedData(parsedData);
        console.log('📩 Gelen SignalR verisi:', parsedData);
      } catch (error) {
        console.error('❌ JSON parse hatası:', error);
        setReceivedData(null);
      }
    });

    return () => {
      connection.off('receiveflowvalue');
      connection.stop();
    };
  }, [connection, flowId]);

  return receivedData;
};
